import { useQuery } from '@apollo/client';

import { GET_HIRER_ACCOUNT } from '../graphql/Queries';

export const useHirerAccount = (orderId: string) => {
  const { data, loading, error } = useQuery(GET_HIRER_ACCOUNT, {
    fetchPolicy: 'network-only',
    skip: !Boolean(orderId),
  });

  return {
    loading,
    hirerAccount: data?.hirerAccount,
    error,
  };
};
